export default __webpack_public_path__ + "static/media/TheNewYear_15.848847eb.png";